import {Route, Routes, useParams} from 'react-router-dom';
import Player from "./Player.tsx";

function App() {

    const {urlCode} = useParams<{urlCode: string}>();
    console.log('urlCode app', urlCode);

    return (
        <div id="container">
                <Routes>
                    <Route index element={
                        <div
                            className="App"
                        >
                            <Player urlCode={urlCode}/>
                        </div>
                    }>
                    </Route>
                    <Route path="*"
                           element={<div style={{color: 'black'}}><h1>404 Not Found</h1><p>The page you requested does not exist.</p></div>}/>
                </Routes>
        </div>
    )
}

export default App